{
  "name": "PremierGr",
  "version": "2.1.0",
  "engines": {
    "node": ">=18.19.1",
    "npm": ">=10.2.4"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "build:ssr": "ng build && ng run premiergr-docs:server",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:premiergr-docs": "node dist/premiergr-docs/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.9",
    "@angular/cdk": "^18.2.11",
    "@angular/common": "^18.2.9",
    "@angular/compiler": "^18.2.9",
    "@angular/core": "^18.2.9",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "^18.2.0",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.2.9",
    "@angular/platform-browser-dynamic": "^18.2.9",
    "@angular/platform-server": "^18.2.0",
    "@angular/router": "^18.2.9",
    "@angular/ssr": "^18.2.10",
    "@netlify/angular-runtime": "^2.1.0",
    "@types/html2canvas": "^0.5.35",
    "@types/nodemailer": "^6.4.17",
    "express": "^4.18.2",
    "firebase": "^11.0.1",
    "firebase-admin": "^12.7.0",
    "firebase-functions": "^6.1.0",
    "html2canvas": "^1.4.1",
    "marked": "^12.0.2",
    "ngx-editor": "^18.0.0",
    "ngx-markdown": "^18.1.0",
    "nodemailer": "^6.9.16",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.10",
    "@angular/cli": "^18.2.10",
    "@angular/compiler-cli": "^18.2.9",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.4.0"
  }
}
